import { memo } from 'react';

import Month from '@calendar/components/Month';
import useMonthsToRenderStore from '@calendar/store/useMonthsToRenderStore';

const MonthList = () => {
  const { monthsToRender } = useMonthsToRenderStore();

  return (
    <>
      {monthsToRender.map((monthToRender, index) => (
        <Month
          key={Number(monthToRender.month)}
          renderMountTitle={index !== 0}
          monthToRender={monthToRender}
          ref={monthToRender.ref}
        />
      ))}
    </>
  );
};

export default memo(MonthList);
